<template>
  <a-drawer
    v-model:visible="trackRecordVisible"
    class="custom-class"
    root-class-name="root-class-name"
    :root-style="{ color: 'blue' }"
    title="患者进度跟踪"
    :maskClosable="false"
    width="332"
    placement="right"
  >
    <div class="reocrdDrawer-content">
      <a-timeline v-if="recordList && recordList.length">
        <a-timeline-item v-for="(item, index) in recordList" :key="index" color="#1890FF">
          <div class="time">{{ item.time }}</div>
          <div class="title">{{ item.title }}</div>
        </a-timeline-item>
      </a-timeline>
      <a-empty v-else />
    </div>
  </a-drawer>
</template>

<script setup>
import { ref, defineProps, defineExpose, computed } from 'vue'
import { requireFollowList } from '@/api/workPlace/workOrder'

const props = defineProps({
  workOrderGroupInfo: {
    type: Object,
    default: () => {},
    requited: true
  }
})
const trackRecordVisible = ref(false)
const ucPatientId = computed(() => props.workOrderGroupInfo.patientInfo.ucUserId)
const workOrderId = computed(() => props.workOrderGroupInfo.targetWorkOrder.workOrderId)
const recordList = ref([])
const showDrawer = () => {
  recordList.value = []
  trackRecordVisible.value = true
  requireFollowList({
    ucPatientId: ucPatientId.value,
    workOrderId: workOrderId.value
  }).then(res => {
    console.log('res', res)
    recordList.value = res && res.length ? res : []
  })
}

defineExpose({
  showDrawer
})
</script>
<style lang="scss" scoped>
.time {
  font-weight: 400;
  font-size: 12px;
  color: #999999;
}
.title {
  font-weight: 400;
  font-size: 16px;
  color: #1c1c1c;
}

.reocrdDrawer-content {
  ::v-deep(.ant-timeline-item-head) {
    background-color: #1890ff !important;
  }
}
</style>
